"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _lab = require("@material-ui/lab");
var _styles = require("@material-ui/core/styles");
var _reactI18next = require("react-i18next");
var _input = _interopRequireDefault(require("../form/input"));
var _forgotpassword = _interopRequireDefault(require("./forgotpassword"));
var _getUserToken = _interopRequireDefault(require("../../utils/push-notifications/getUserToken"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _styles.makeStyles)(() => ({
  form: {
    userSelect: "none",
    width: "100%"
  }
}));
const LoginForm = props => {
  const css = useStyles();
  const [usernameError, setUsernameError] = (0, _react.useState)(false);
  const [passwordError, setPasswordError] = (0, _react.useState)(false);
  const [showForgotPassword, setShowForgotPassword] = (0, _react.useState)(false);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const {
    targetPageIsLoginLayout
  } = props;
  const [message, setMessage] = (0, _react.useState)({
    type: "",
    description: ""
  });
  const handleLogin = async e => {
    e.preventDefault();
    const userToken = (0, _getUserToken.default)();
    const formData = new FormData(e.target);
    formData.append("jsonResponse", 1);
    formData.append("userToken", userToken);
    const hasFormErrors = validateForm(formData);
    if (hasFormErrors) {
      setMessage(prevState => ({
        ...prevState,
        type: "error",
        description: t("site.login.errors.mandatoryfields")
      }));
      return null;
    }
    const response = await fetch("".concat(process.env.REACT_APP_PATH, "/login.internal"), {
      method: "POST",
      body: formData
    });
    const data = await response.json();
    if (data.state === 0) {
      // success, save token
      localStorage.setItem("logintoken", data.token);
      setMessage(prevState => ({
        ...prevState,
        type: "success",
        description: t("site.login.success")
      }));
      setTimeout(() => {
        if (targetPageIsLoginLayout) {
          // if targetPageIsLoginLayout is login -> redirect to homepage
          window.location.href = "/";
        } else {
          // if not -> reload page
          window.location.reload();
        }
      }, 1000);
    }
    if (data.state === 1) {
      // failed
      setMessage(prevState => ({
        ...prevState,
        type: "error",
        description: t("site.login.errors.logindata")
      }));
    }
  };
  const validateForm = formData => {
    let hasError = false;
    if (!formData.get("username")) {
      setUsernameError(true);
      hasError = true;
    }
    if (!formData.get("password")) {
      setPasswordError(true);
      hasError = true;
    }
    if (hasError) {
      return true;
    }
    return false;
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !showForgotPassword ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Box, {
    mb: 1
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, null, t("site.login.text"))), /*#__PURE__*/_react.default.createElement("form", {
    className: css.form,
    onSubmit: handleLogin
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 3
  }, /*#__PURE__*/_react.default.createElement(_input.default, {
    name: "username",
    label: t("site.login.labels.username"),
    autoFocus: true,
    autoComplete: "username",
    error: usernameError,
    onChange: e => setUsernameError(e.target.value !== "" ? false : true)
  })), /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 3
  }, /*#__PURE__*/_react.default.createElement(_input.default, {
    name: "password",
    label: t("site.login.labels.password"),
    type: "password",
    autoComplete: "current-password",
    error: passwordError,
    onChange: e => setPasswordError(e.target.value !== "" ? false : true)
  })), message.description ? /*#__PURE__*/_react.default.createElement(_core.Box, {
    my: 3
  }, /*#__PURE__*/_react.default.createElement(_lab.Alert, {
    severity: message.type
  }, message.description)) : "", /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 3
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    color: "primary",
    fullWidth: true,
    size: "large",
    disableElevation: true,
    type: "submit"
  }, t("site.login.labels.login"))), /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Link, {
    component: "button",
    variant: "body2",
    color: "primary",
    onClick: () => {
      setShowForgotPassword(true);
    }
  }, t("site.login.labels.forgotPassword"))))) : /*#__PURE__*/_react.default.createElement(_forgotpassword.default, {
    setShowForgotPassword: setShowForgotPassword
  }));
};
var _default = exports.default = LoginForm;